import styled from "styled-components";
import { bodyColor } from "../../../config/constants";
import DatePicker from "react-datepicker";

export const RangeDatesDiv = styled.div`
  display: flex;
  align-items: center;
  @media (max-width: 700px) {
    flex-direction: column;
  }
`;
export const RangeDatesLabel = styled.p`
  margin-right: 20px;
  font-size: 14px;
  font-weight: bold;
  color: #000;
  @media (max-width: 700px) {
    margin-right: 0;
  }
`;
export const DateInputDiv = styled.div`
  width: 150px;
  @media (max-width: 700px) {
    margin-top: 10px;
  }
`;
export const DateInput = styled(DatePicker)`
  padding: 5px 10px;
  width: 100%;
  border: 1px solid ${bodyColor};
  outline: none;
  border-radius: 5px;
  font-size: 14px;
  cursor: pointer;
`;
export const RangeDatesSeparator = styled.div`
  width: 20px;
  height: 1px;
  background-color: ${bodyColor};
  @media (max-width: 700px) {
    display: none;
  }
`;
